export default __webpack_public_path__ + "static/media/label_onsale.362fa28e.svg";